import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./assets/scss/styles.scss";

import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Error404 from "./components/Error404";
import WhatsAppFlotante from "./components/WhatsAppFlotante/WhatsAppFlotante";
import Slider from "./components/Slider";

// import { Col, Container, Row } from "react-bootstrap";

function App() {
  return (
    <div style={{ height: "100vh" }}>
      <Router>
        <Switch>
          <Route path="/consultas/:slug?">
            <div className="d-flex flex-column vh-100">
              <Header />

              <main className="flex-grow-1 d-flex align-items-center justify-content-center bg-black">
                <Slider />
              </main>
              <Footer />
            </div>
          </Route>

          <Route path="*">
            <Header bg="bgDark" />
            <Error404 />
            <Footer />
          </Route>
        </Switch>
        <WhatsAppFlotante />
      </Router>
    </div>
  );
}

export default App;
